// extracted by mini-css-extract-plugin
module.exports = {"capacity":"ApiUsage_capacity__LuJDa","textContainer":"ApiUsage_textContainer__wa0Jt"};